import { Wrapper } from 'components/Pages/Wine/View/Main/Content/ColumnRight/_styles'
import Awards from '../Awards'
import ServingSuggestions from './ServingSuggestions'
import NutritionDeclaration from './NutritionDeclaration'
import Certificates from './Certificates'
import ResponsibleConsumption from './ResponsibleConsumption'

const ColumnRight = () => {
  return (
    <Wrapper>
      <Awards />
      <ServingSuggestions />
      <NutritionDeclaration />
      <Certificates />
      <ResponsibleConsumption />
    </Wrapper>
  )
}

export default ColumnRight
